var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_BULK_ERROR_DOWNLOAD_REQUEST, fetchBulkErrorDownloadFailure, fetchBulkErrorDownloadSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onFetchGetBulkErrorDownload = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(`cnvt/bulk/error/${action.payload.bulkId}`, {
                file_format: action.payload.file_format,
            })
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchGetBulkErrorDownloadWorker(action) {
    try {
        const data = yield call(onFetchGetBulkErrorDownload, action);
        yield put(fetchBulkErrorDownloadSuccess(data));
    }
    catch (error) {
        yield put(fetchBulkErrorDownloadFailure(error));
    }
}
export function* watchGetBulkErrorDownloadData() {
    yield takeLatest(FETCH_BULK_ERROR_DOWNLOAD_REQUEST, fetchGetBulkErrorDownloadWorker);
}
